<template>
  <div>
    <v-layout row wrap >
      
      <v-flex
        xs12
        pt-2
        :class="{'ml-5': $vuetify.breakpoint.mdAndUp}"
        style="display: flex;"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              large
              color="primary"
              outline
              :block="$vuetify.breakpoint.smAndDown"
              class="ml-0 text-none"
              @click="open()"
            >
              <wz-avatar
                :username="bot[0].USR_FIRST_NAME  + ' ' + bot[0].USR_LAST_NAME"
                :src="`${domaine}/public/media/user/small/${bot[0].USR_ID}_avatar.jpg`"
                size="35px"
              ></wz-avatar>
              &nbsp;{{ bot[0].USR_FIRST_NAME + ' ' + bot[0].USR_LAST_NAME }}
            </v-btn>
          </template>
          <span>{{ $t('selectchatbot') }}</span>
        </v-tooltip>
      </v-flex>
              
    </v-layout>
    <!-- Sélectionner le bot -->
    <v-dialog v-model="dialog" scrollable persistent max-width="350px">
      <v-card>
        <v-card-title class="primary white--text">
          <div class="title">
            <v-btn icon @click="cancel()"><v-icon class="white--text">close</v-icon></v-btn>
            {{ $t('selectchatbot') }}
          </div>
        </v-card-title>

        <v-card-text style="height: 400px;">
          <v-radio-group v-model="selectedBot[0]">
            <v-radio
              v-for="(lebot, i) in listeBots"
              :key="i"
              :value="lebot"
            >
              <template v-slot:label>
                <div>
                  <wz-avatar
                  :username="lebot.USR_FIRST_NAME  + ' ' + lebot.USR_LAST_NAME"
                  :src="`${domaine}/public/media/user/small/${lebot.USR_ID}_avatar.jpg`"
                  size="35px"
                ></wz-avatar>
                <span class="ml-2">
                  {{ lebot.USR_FIRST_NAME + ' ' + lebot.USR_LAST_NAME }}
                </span>
                <span v-if="(lebot.USR_ID == $store.state._User.id)">
                  ({{ $t('me') }})
                </span>
                </div>
              </template>
            </v-radio>
          </v-radio-group>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="cancel()">{{ $t('cancel') }}</v-btn>
          <v-btn :disabled="selectedBotId === selectedBot[0].USR_ID" color="primary" @click="submit()">{{ $t('submit') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapMutations } from 'vuex'
import { DOMAINE } from '../../constants'
export default {
  props: {
    /**
     * Bot sélectionné
     */
    bot: {
      type: Array,
      required: true
    },
    /**
     * Bots sélectionnables
     */
    listeBots: {
      type: Array,
      required: true
    },
    /**
     * Indique si l'utilisateur
     * ne doit pas apparaître dans
     * la liste des bots
     */
    withoutMe: {
      type: Boolean,
      default: false
    },
    testChatbot: {
      type: Boolean,
      default: true
    },
    openFromExt: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      domaine: DOMAINE,
      /**
       * Indique si le dialog est ouvert
       * @type {Boolean}
       */
      dialog: false,
      selectedBotId: null,
      selectedBotBKP: [],
      selectedBot: []
    }
  },

  created () {
    this.selectedBot = _.cloneDeep(this.bot)
  },

  computed: {},

  methods: {
    ...mapMutations('_User', [
      'SET_SELECTEDBOT'
    ]),
    open () {
      console.log('open liste bot')
      this.dialog = true
      this.selectedBot = _.cloneDeep(this.bot)
      this.selectedBotId = this.bot[0].USR_ID
      this.selectedBotBKP = _.cloneDeep(this.bot) // remet le bot actif au moment de l'ouverture de la dialogBox
    },
    // envois le nouveau bot selectionné
    submit () {
      // console.log('submit selectedBot', this.selectedBot)
      // console.log('submit bot', this.bot)
      // console.log('submit listeBots', this.listeBots)
      // this.$emit('update:bots', this.selectedBot[0])
      this.SET_SELECTEDBOT(this.selectedBot)
      this.$emit('reInitBots')
      this.dialog = false
      // this.$emit('closeListe')
    },
    // ferme la fenetre choix bot
    cancel () {
      // console.log('cancel', this.selectedBotBKP)
      // this.bot = this.selectedBotBKP
      // this.selectedBot = this.selectedBotBKP
      // this.SET_SELECTEDBOT(this.selectedBotBKP)
      // this.$emit('reInitBots')
      this.dialog = false
      this.$emit('closeListe')
    },
    // open target front pour test chatbot
    openFront () {
      /* eslint-disable */
      if (typeof openPanel === 'function') {
        resetConversation(this.$store.state._User.botSelected[0].USR_IS_BOT, "tfstart", "0")
        openPanel()
		    if(document.getElementsByClassName('currentAgentName') && document.getElementsByClassName('currentAgentName')[0])
			    document.getElementsByClassName('currentAgentName')[0].innerHTML = "Simulateur de chatbot"
        if(document.getElementsByClassName('currentAgentJob') && document.getElementsByClassName('currentAgentJob')[0])
			    document.getElementsByClassName('currentAgentJob')[0].innerHTML = "Chaque apprentissage prend quelques instants"

        if(document.getElementById('WatchBox-BTsettings'))
          document.getElementById('WatchBox-BTsettings').style.display = 'none'
        // console.log('this.bot')
        // console.log(this.bot[0].USR_IS_BOT)
      }
      /* eslint-enable */
    }
  },

  watch: {
    openFromExt (val, oldVal) {
      if (this.openFromExt) {
        console.log('open liste bot depuis la mindmap')
        this.open()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzSelectBots.vue